import { CreatorError, creatorConfig } from './creatorDomain.ts';
const allowedUrls = new Set<string>(Object.values(creatorConfig).flatMap(c => [c.token, c.resource, ...(c.userinfo ? [c.userinfo] : [])]));
export async function creatorFetch(url: string, init: RequestInit, transport: typeof fetch = fetch) {
  if (!allowedUrls.has(url)) throw new CreatorError('invalid_provider_url');
  const res = await transport(url, {...init, redirect: 'error', signal: AbortSignal.timeout(20000)});
  if (!res.ok) {
    const provider = Object.entries(creatorConfig).find(([, config]) => config.token === url || config.resource === url || config.userinfo === url)!;
    console.warn('creator_provider_http', provider[0], provider[1].token === url ? 'token' : provider[1].userinfo === url ? 'userinfo' : 'resource', res.status);
    await res.body?.cancel();
    throw new CreatorError(res.status === 401 ? 'reconnect_required' : res.status === 403 ? 'permissions_incomplete' :
      res.status === 429 ? 'provider_rate_limited' : 'provider_unavailable', res.status === 429 ? 429 : 502);
  }
  return res;
}
export async function readBounded(res: Response, max = 1000000): Promise<string> {
  const reader = res.body?.getReader();
  if (!reader) return '';
  const chunks: Uint8Array[] = []; let size = 0;
  try {
    for (;;) {
      const {done, value} = await reader.read(); if (done) break;
      size += value.length;
      if (size > max) throw new CreatorError('provider_result_too_large', 502);
      chunks.push(value);
    }
    const bytes = new Uint8Array(size); let offset = 0;
    for (const chunk of chunks) { bytes.set(chunk, offset); offset += chunk.length; }
    return new TextDecoder('utf-8', {fatal: true}).decode(bytes);
  } finally { await reader.cancel().catch(() => {}); reader.releaseLock(); }
}
export async function creatorJson(url: string, init: RequestInit, transport: typeof fetch = fetch) {
  return JSON.parse(await readBounded(await creatorFetch(url, init, transport)));
}
